import gsap from 'gsap';

export class Collapse {
	constructor( selector, options = {} ) {
		this.elements = document.querySelectorAll( selector );
		this.options = options;
		this.duration = options.duration || 0.3;
		this.ease = options.ease || 'power1.inOut';
		this.isEnable = false;
	}

	init() {
		if ( this.isEnable ) return;
		if ( ! this.elements?.length ) return;
		this.isEnable = true;
		this.elements.forEach( ( container ) => {
			const allItems = gsap.utils.toArray(
				'.mk-collapse-item',
				container
			);
			allItems.forEach( ( item, index ) => {
				const theHead = item.querySelector( '.el-head' );
				const theBody = item.querySelector( '.el-body' );
				const foldIcon = theHead.querySelector( '.fold-icon' );
				const expandIcon = theHead.querySelector( '.expand-icon' );
				theHead.addEventListener( 'click', () =>
					this.clickHandler(
						item,
						theHead,
						theBody,
						foldIcon,
						expandIcon,
						allItems,
						index
					)
				);
				if ( this.options.initExpand === 'expandFirst' ) {
					if ( ! index ) {
						item.classList.add( 'expanded' );
						theHead.setAttribute( 'aria-expanded', 'true' );
						theBody.setAttribute( 'aria-expanded', 'true' );
						gsap.set( theBody, {
							display: 'block',
							height: 'auto',
						} );
						gsap.set( foldIcon, {
							display: 'none',
						} );
						gsap.set( expandIcon, { display: 'flex' } );
					} else {
						theHead.setAttribute( 'aria-expanded', 'false' );
						theBody.setAttribute( 'aria-expanded', 'false' );
						gsap.set( theBody, { display: 'none', height: 0 } );
						gsap.set( foldIcon, {
							display: 'flex',
						} );
						gsap.set( expandIcon, { display: 'none' } );
					}
				} else if ( this.options.initExpand === 'fold' ) {
					theHead.setAttribute( 'aria-expanded', 'false' );
					theBody.setAttribute( 'aria-expanded', 'false' );
					gsap.set( theBody, { display: 'none', height: 0 } );
					gsap.set( foldIcon, {
						display: 'flex',
					} );
					gsap.set( expandIcon, { display: 'none' } );
				} else {
					gsap.set( foldIcon, {
						display: 'none',
					} );
					gsap.set( expandIcon, { display: 'flex' } );
				}
			} );
		} );
	}

	kill() {}
	resize() {}
	destroy() {}

	clickHandler(
		theItem,
		theHead,
		theBody,
		foldIcon,
		expandIcon,
		allItems,
		index
	) {
		const aniVars = { duration: this.duration, ease: this.ease };
		if ( this.options.delay ) aniVars.delay = this.options.delay;
		if ( this.options.autoFold ) {
			allItems.forEach( ( item, newIndex ) => {
				if ( index !== newIndex ) {
					const isExpand = item.classList.contains( 'expanded' );
					if ( isExpand ) {
						const itemHead = item.querySelector( '.el-head' );
						const itemBody = item.querySelector( '.el-body' );
						const itemFoldIcon = item.querySelector( '.fold-icon' );
						const itemExpandIcon =
							item.querySelector( '.expand-icon' );
						item.classList.remove( 'expanded' );
						itemHead.setAttribute( 'aria-expanded', 'false' );
						itemBody.setAttribute( 'aria-expanded', 'false' );
						gsap.killTweensOf( itemBody );
						gsap.to( itemBody, {
							display: 'none',
							height: 0,
							...aniVars,
						} );
						gsap.fromTo(
							itemExpandIcon,
							{
								rotate: '0',
								opacity: 1,
								display: 'flex',
							},
							{
								rotate: '180deg',
								opacity: 0,
								display: 'none',
								duration: 0.2,
							}
						);
						gsap.fromTo(
							itemFoldIcon,
							{
								rotate: '-90deg',
								opacity: 0,
								display: 'none',
							},
							{
								rotate: 0,
								opacity: 1,
								display: 'flex',
								duration: 0.1,
								delay: 0.1,
							}
						);
					}
				}
			} );
		}
		const isExpanded = theHead.getAttribute( 'aria-expanded' );
		if ( isExpanded === 'true' ) {
			theItem.classList.remove( 'expanded' );
			theHead.setAttribute( 'aria-expanded', 'false' );
			theBody.setAttribute( 'aria-expanded', 'false' );
			gsap.killTweensOf( theBody );
			gsap.to( theBody, { display: 'none', height: 0, ...aniVars } );
			gsap.fromTo(
				expandIcon,
				{
					rotate: '0',
					opacity: 1,
					display: 'flex',
				},
				{
					rotate: '180deg',
					opacity: 0,
					display: 'none',
					duration: 0.2,
				}
			);
			gsap.fromTo(
				foldIcon,
				{
					rotate: '-90deg',
					opacity: 0,
					display: 'none',
				},
				{
					rotate: 0,
					opacity: 1,
					display: 'flex',
					duration: 0.1,
					delay: 0.1,
				}
			);
		} else {
			theItem.classList.add( 'expanded' );
			theHead.setAttribute( 'aria-expanded', 'true' );
			theBody.setAttribute( 'aria-expanded', 'true' );
			gsap.killTweensOf( theBody );
			gsap.set( theBody, { display: 'block' } );
			gsap.to( theBody, {
				height: 'auto',
				...aniVars,
			} );
			gsap.fromTo(
				foldIcon,
				{
					rotate: '0',
					opacity: 1,
					display: 'flex',
				},
				{
					rotate: '-180deg',
					opacity: 0,
					display: 'none',
					duration: 0.2,
				}
			);
			gsap.fromTo(
				expandIcon,
				{
					rotate: '90deg',
					opacity: 0,
					display: 'none',
				},
				{
					rotate: 0,
					opacity: 1,
					display: 'flex',
					duration: 0.1,
					delay: 0.1,
				}
			);
		}
	}
}
